<template>
  <div>
    <b-container>
      <b-row id="view">
        <b-col>
          <div v-for="course in participations_sorted" :key="course.nom_course">
            <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon>{{ course[0].nom_course }}</h2>
            <b-table id="table_classement" hover small responsive :items="course" :fields="fields">
              <template #cell(nom)="data">
                <b-form-input style="min-width: 80px" v-model="data.item.nom"></b-form-input>
              </template>
              <template #cell(prenom)="data">
                <b-form-input style="min-width: 80px" v-model="data.item.prenom"></b-form-input>
              </template>
              <template #cell(annee_naissance)="data">
                <b-form-input style="min-width: 80px" v-model="data.item.annee_naissance"></b-form-input>
              </template>
              <template #cell(enregistrer)="data">
                <b-button class="correction_btn" @click="saveParticipation(data.item)">Corriger</b-button>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- <b-table id="table_classement" hover small responsive :items=""> </b-table> -->
    <div class="floated_save">
      <div class="inner_floated" v-if="!done">
        <p>Une fois les corrections effectuées, cliquez ici pour recalculer les classements</p>
        <div class="sep"></div>
        <b-button @click="recomputeClassement()">Tout recalculer</b-button>
      </div>
      <div class="inner_floated" v-else>
        <p>Les classements ont étés mis à jour. Vous pouvez quitter cette page.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      participations_sorted: [],
      done: false,
      fields: [
        { key: "nom" },
        { key: "prenom" },
        { key: "annee_naissance" },
        { key: "categorie" },
        { key: "temps" },
        { key: "classement_scratch" },
        { key: "classement_sexe" },
        { key: "classement_cat" },
        { key: "classement_sexe" },
        { key: "enregistrer" },
      ],
    };
  },
  methods: {
    saveParticipation(data) {
      axios.post(this.$store.state.base_url + "/participation/post.php", data).then(function () {});
    },
    recomputeClassement() {
      var _this = this;
      axios.get(this.$store.state.base_url + "/participations/recompute.php").then(function () {
        _this.done = true;
      });
    },
  },

  created() {
    var _this = this;
    axios.get(this.$store.state.base_url + "/participations/get.php").then(function (response) {
      _this.participations_sorted = response.data;
    });
  },
};
</script>

<style lang="scss">
</style>